// Single source of truth for the API base URL.
//
// Why a runtime helper instead of just inlining `${process.env.REACT_APP_BACKEND_URL}/api`
// everywhere?
//
//   - In production the Kubernetes ingress already routes `/api/*` from the
//     public hostname to the FastAPI backend. So same-origin always works:
//     `https://unisol.global/api/...` reaches the API on its own.
//   - Cross-origin setups (production frontend on `unisol.global`, API on a
//     different `*.emergent.host` host) trigger:
//        * Safari "Intelligent Tracking Prevention" — cookies dropped.
//        * `Access-Control-Allow-Origin: *` + `credentials: include` — invalid
//          CORS combination, every modern browser silently rejects the
//          response (Safari is strictest, hence the iPad login failures).
//   - By preferring `window.location.origin` whenever the page is served from
//     a real hostname, we sidestep both problems entirely. The build-time
//     `REACT_APP_BACKEND_URL` is kept as a fallback for local `yarn start`
//     dev (where the page is on `localhost:3000` but the API is on
//     `localhost:8001`).

const inBrowser = typeof window !== 'undefined' && !!window.location;

const isLocalDev =
  inBrowser &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// In local dev fall back to the env var (which points to the local backend).
// Anywhere else, use the current origin — the ingress proxies /api → backend.
const base = isLocalDev
  ? (process.env.REACT_APP_BACKEND_URL || window.location.origin)
  : (inBrowser ? window.location.origin : process.env.REACT_APP_BACKEND_URL);

export const API_BASE = base;
export const API = `${base}/api`;
